<template>
  <div class="list-con">
    <div class="list-title">企业信息</div>
    <div class="list-table">
      <div class="search">
        <el-input style="width:240px" size="medium" placeholder="请输入企业名称" v-model="enterpriseParams.keyword" clearable @clear="getSearchList" @keyup.enter.native="getSearchList"></el-input>
      </div>
      <div class="table-box">
        <el-table :data="enterpriseList" style="width: 100%" :header-cell-style="{color:'#B4B4B4',height:'36px',border:'none',padding:0, background:'rgba(0,77,160,0.05)'}" :row-style="{height:'48px',padding:'0',background:'rgba(0,77,160,0.05)', borderRadius:'5px'} " :cell-style=" {fontSize:'14px',padding:0,border:'none',color:'#5C5C5C'}">
          <el-table-column label="企业名称" prop="enterpriseName" show-overflow-tooltip />
          <el-table-column label="子链数" prop="childChainName" />
          <el-table-column label="智能合约数" prop="chaincodeNum"></el-table-column>
          <el-table-column label="总交易量" prop="transactionNumTotal" />
          <el-table-column label="前一年交易量" prop="transactionNumLastYear" />
          <el-table-column label="今年交易量" prop="transactionNumThisYear" />
          <el-table-column label="最后操作时间" prop="updateTime" show-overflow-tooltip />
        </el-table>
      </div>

    </div>

    <pagination :total="total" :page.sync="enterpriseParams.page_num" :limit.sync="enterpriseParams.page_size" @pagination="getEnterpriseList" />
  </div>

</template>

<script>
import { getEnterpriseList } from '@/api/enterprise';
export default {
  data() {
    return {
      enterpriseParams: {
        page_num: 1,
        page_size: 10,
        keyword: ''
      },
      enterpriseList: [],
      total: 0
    }
  },
  mounted() {
    this.getEnterpriseList()
  },
  methods: {
    async getEnterpriseList() {
      const res = await getEnterpriseList(this.enterpriseParams)
      this.enterpriseList = res.data
      this.total = Number(res.totalCount)
    },

    getSearchList() {
      this.enterpriseParams.page = 1
      this.getEnterpriseList()
    }
  }
}
</script>

<style lang="less" scoped>
.list-title {
  margin-bottom: 28px;
}
</style>
